export default "__VITE_ASSET__OsT_nAA6__"